/* Packages */
import React from 'react';
import {render} from 'react-dom';

/* Helpers */
import {parseDataToProps} from '../helpers';

const toastContainerNodes = document.querySelectorAll('.toast-container');

if (toastContainerNodes.length > 0) {
    import(/* webpackChunkName: "ReactToastContainer" */ './components/ReactToastContainer').then(({default: ReactToastContainer}) => {
        [...toastContainerNodes].forEach((node) => render(
            <ReactToastContainer {...parseDataToProps(node.dataset)} />, node));
    });
}
